// jhtest.esvtek.com:15666/driver

// import request from '@/utils/request'
import axios from 'axios'

const BaseUrl = process.env.NODE_ENV === 'development' ? 'https://jhtest.esvtek.com:15666/driver' : 'https://jacwxmp.starnetah.com:19000/driver'

// 获取积分活动结束时间
export default function getTimeIsEnd() {
  return axios.get(`${BaseUrl}/active/timeIsEndBy11`, {
    withCredentials: false
  })
}
